import { ProductionBug } from '../../types';
import { getBugTableCells } from 'domain/projects/newProject/engineering/List/getBugTableCells';
import ControlListSection from '../../shared/ControlListSection';

const ProductionBugsSection = ({
  title,
  bugs,
  emptyMessage,
}: {
  title: string;
  bugs: ProductionBug[];
  emptyMessage: string;
}) => {
  return (
    <ControlListSection
      title={title}
      items={bugs}
      listSource="bugs"
      emptyMessage={emptyMessage}
      getTableCells={() => Promise.resolve(getBugTableCells({ createdAtSize: 3, notesFieldSize: 2 }))}
    />
  );
};

export default ProductionBugsSection;
